import { useState } from "react";
import { useField } from "formik";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
//import FormAlert from "../Alert/FormAlert";
import { useTheme } from "@mui/material";

const TextInput = ({ label, ...props }) => {
  const [field, meta] = useField(props);
  const theme = useTheme();
  const [showError, setShowError] = useState(true);

  return (
    <>
      <Box
  sx={{
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    "& .MuiTextField-root": { mt: 2, width: "100%" },
  }}
>
        <TextField
          variant="outlined"
          label={label}
          fullWidth
          size="small"
          margin="normal"
          {...field}
          {...props}
          error={Boolean(meta.touched && meta.error)}
          helperText={meta.touched && meta.error ? meta.error : ""}
          sx={{
           
            "& .MuiInputBase-input": {
              fontSize: '1rem',
              color: theme.palette.mode === 'dark'
                ? theme.palette.grey[100]
                : theme.palette.grey[900],
              fontWeight: 400,
            },
            "& .MuiInputLabel-root": {
              color: theme.palette.mode === 'dark' ? theme.palette.grey[100] : theme.palette.grey[900],
              fontWeight:400,
              fontSize: '0.8rem'
            },
            "& .MuiInputLabel-root.Mui-focused": {
              color: theme.palette.mode === 'dark' ? theme.palette.grey[100] : theme.palette.grey[900],
            },

            "& .MuiOutlinedInput-root": {
              backgroundColor: theme.palette.background.default,
              transition: "border-color 0.2s ease",
              "&:hover": {
                backgroundColor: theme.palette.background.default,
              },
              "& .MuiOutlinedInput-notchedOutline": {
                borderColor: theme.palette.mode === 'dark' ? theme.palette.grey[100] : theme.palette.grey[900],
                transition: "border-color 0.2s ease",
              },
              "&:hover .MuiOutlinedInput-notchedOutline": {
                borderColor: theme.palette.mode === 'dark' ? theme.palette.grey[100] : theme.palette.grey[900],
              },
              "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                borderColor: theme.palette.mode === 'dark' ? theme.palette.grey[100] : theme.palette.grey[900],
                borderWidth: 2,
              },
            },
              "&.Mui-focused": {
                backgroundColor: theme.palette.background.default,
                color: "grey.C900",
                boxShadow: "none",
              },
              
              "& input": {
                backgroundColor: "transparent",
                "&:-webkit-autofill": {
                  WebkitBoxShadow: `0 0 0 1000px ${theme.palette.background.default} inset !important`,
                },
              },
            
          }}
        />
      </Box>

      
    </>
  );
};

export default TextInput;


/* removed 
{meta.touched && meta.error && showError && (
        <FormAlert
          severity="warning"
          message={meta.error}
          onClose={() => setShowError(false)}
        />
      )}
*/
